import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import arrayMutators from 'final-form-arrays';
import { propTypes } from '../../util/types';
import { required } from '../../util/validators';
import config from '../../config';
import { Form, Button, FieldTextInput, FieldCheckboxGroup, FieldSelect } from '../../components';
import { findOptionsForSelectFilter } from '../../util/search';
import css from './EditListingPoliciesForm.module.css';

export const EditListingPoliciesFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        filterConfig,
        fetchErrors,
      } = formRenderProps;


      const parkingHeightLabelMessage = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.parkingHeightLabel',
      });

      const parkingHeightPlaceholderMessage = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.parkingHeightPlaceholder',
      });
      

      const parkingLevelLabelMessage = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.parkingLevelLabel',
      });

      const parkingLevelPlaceholderMessage = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.parkingLevelPlaceholder',
      });
      

      

      const attentionLabel = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.attentionLabel',
      });

      const cancellationLabel = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.cancellationLabel',
      });



      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingPracticalInfoForm.updateFailed" />
        </p>
      ) : null;
      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingPracticalInfoForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      // const optionsVehicles = findOptionsForSelectFilter('vehicleCompatibility', filterConfig);

      const accessRequired = required(
        intl.formatMessage({
          id: 'EditListingAccessForm.accessRequired',
        })
      );
      const options = findOptionsForSelectFilter('vehicleCompatibility', filterConfig);

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          <br/>
          <br/>
          {/* <FieldCheckboxGroup className={css.vehicleCompatibility} id="vehicleCompatibility" name="vehicleCompatibility" options={optionsVehicles} /> */}

          <FieldTextInput
            id="parkingHeight"
            name="parkingHeight"
            className={css.policy}
            type="text"
            label={parkingHeightLabelMessage}
            placeholder={parkingHeightPlaceholderMessage}
          />

          <FieldTextInput
            id="parkingLevel"
            name="parkingLevel"
            className={css.policy}
            type="text"
            label={parkingLevelLabelMessage}
            placeholder={parkingLevelPlaceholderMessage}
          />

          <p className={css.label}>Quel type de véhicule peuvent stationner dans votre parking </p>
          <FieldCheckboxGroup className={css.features} id={'vehicleCompatibility'} name={'vehicleCompatibility'} options={options} />

          {/* <FieldTextInput
            id="parkingWayToOpen"
            name="parkingWayToOpen"
            className={css.policy}
            type="textarea"
            label={parkingWayToOpenLabelMessage}
            placeholder={parkingWayToOpenPlaceholderMessage}
          /> */}

        {/* <FieldSelect
          className={css.extraInfo}
          name="attention"
          id="attention"
          label={attentionLabel}
          validate={accessRequired}
        >
          <option disabled value="">
            {" "}
          </option>
            <option key={"oui"} value={"oui"}>
              {"oui"}
            </option>
            <option key={"non"} value={"non"}>
              {"non"}
            </option>
         
        </FieldSelect>


        <FieldSelect
          className={css.extraInfo}
          name="cancellation"
          id="cancellation"
          label={cancellationLabel}
          validate={accessRequired}
        >
          <option disabled value="">
            {" "}
          </option>
            <option key={"oui"} value={"oui"}>
              {"oui"}
            </option>
            <option key={"non"} value={"non"}>
              {"non"}
            </option>
         
        </FieldSelect> */}


 <p className={css.notMandatoryWarning}>Ces informations ne sont pas obligatoires, n'hésitez pas à appuyer sur "suivant" si vous ne souhaitez pas les compléter</p> 


          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingPoliciesFormComponent.defaultProps = {
  filterConfig: config.custom.filters,
  selectedPlace: null,
  updateError: null,
};

EditListingPoliciesFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  selectedPlace: propTypes.place,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  filterConfig: propTypes.filterConfig,
};

export default compose(injectIntl)(EditListingPoliciesFormComponent);
